import React, { useMemo } from 'react';

import _ from 'lodash';

import { useQueryGetOpcProjectsList } from 'api/queries/getOpcProjectsList.query';

import classes from './OpcVerifiedAccess.module.scss';

const SUCCESS_SUBTITLE =
    'The connection has been tested successfully and can access the following Oracle Primavera Cloud resources.';
const ERROR_SUBTITLE = 'Unable to verify access due to connection issue.';

export const OpcVerifiedAccess = () => {
    const { data, isError } = useQueryGetOpcProjectsList();

    const workSpaceCount = useMemo(() => {
        const grouped = _.groupBy(data ?? [], 'workspaceOpcId');
        return Object.keys(grouped).length;
    }, [data]);
    const projectsCount = useMemo(() => {
        const grouped = _.groupBy(data ?? [], 'projectOpcId');
        return Object.keys(grouped).length;
    }, [data]);

    return (
        <div className={classes.OpcVerifiedAccess}>
            <div className={classes.text}>
                <div className={classes.title}>Verified Access</div>
                <div className={classes.subtitle}>{isError ? ERROR_SUBTITLE : SUCCESS_SUBTITLE}</div>
            </div>

            <div className={classes.details}>
                <div className={classes.detailsColumn}>
                    <div className={classes.detailsItem}>
                        <div className={classes.detailsLabel}>Workspaces available:</div>
                        <div className={`${classes.detailsValue} ${isError ? classes.detailsValueWarning : ''}`}>
                            {isError ? 'Unable to load' : workSpaceCount}
                        </div>
                    </div>
                    <div className={classes.detailsItem}>
                        <div className={classes.detailsLabel}>Import enabled:</div>
                        <div className={classes.detailsValue}>{isError ? '-' : 'Yes'}</div>
                    </div>
                </div>

                <div className={classes.detailsColumn}>
                    <div className={classes.detailsItem}>
                        <div className={classes.detailsLabel}>Projects available:</div>
                        <div className={`${classes.detailsValue} ${isError ? classes.detailsValueWarning : ''}`}>
                            {isError ? 'Unable to load' : projectsCount}
                        </div>
                    </div>
                    <div className={classes.detailsItem}>
                        <div className={classes.detailsLabel}>Export enabled:</div>
                        <div className={classes.detailsValue}>{isError ? '-' : 'Yes'}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
